export function RouteLoading() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-40 items-center justify-center p-6 text-sm text-slate-500 dark:text-slate-400"
    >
      Loading workspace…
    </div>
  );
}
